import {createAction} from '@reduxjs/toolkit';
import {CreateBreweryDTO, GetBreweryBeersDTO} from 'typescript/dto/BreweriesDto';
import {withPayloadType} from 'typescript/types/PayloadType';

import {singleBreweryNamespace} from './singleBrewerySlice';

const getSingleBreweryACS = createAction(`${singleBreweryNamespace}/getSingleBreweryACS`, withPayloadType<string>());

const getBreweryBeersACS = createAction(
  `${singleBreweryNamespace}/getBreweryBeersACS`,
  withPayloadType<GetBreweryBeersDTO>(),
);

const updateSingleBreweryACS = createAction(
  `${singleBreweryNamespace}/updateSingleBreweryACS`,
  withPayloadType<{id: string; brewery: CreateBreweryDTO}>(),
);

export {getSingleBreweryACS, getBreweryBeersACS, updateSingleBreweryACS};
